<template>
  <div style="min-height: 100vh;background-color: #fff">
    <headNav>
      <div slot="headNavText">{{$t('message.yys_rz')}}</div>
    </headNav>
    <div class="container">
      <div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle circle1">03</div>
        <div class="circle"></div>
      </div>
      <div class="scsf">
        <div>{{$t('message.yys_rz')}}</div>
        <div>{{$t('message.yys_tip')}}</div>
      </div>
    </div>
    <div class="section2">
      <div>
        <div STYLE="padding: 0 16px;">
          <h3>STEP <span>{{step}}</span></h3>
          <van-divider/>
        </div>

        <div v-if="LANGS=='VN'">
          <div style="position: relative">
            <van-field v-model="tel" :label="$t('message.th_yys_sjh')" readonly/>
            <div style="position: absolute;right: 0.8rem;top: 0.33rem">
              <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" />
              </van-dropdown-menu>
            </div>

          </div>
          <div v-show="aisSecACCEPT">
            <van-field v-model="yys_code" :label="$t('message.th_yys_yzm')" :placeholder="$t('message.th_yys_qsryzm')" @input="code2Input"/>
            <div style="color:red;font-size:12px;padding: 10px 16px;" v-show="yysmm">
              {{$t('message.th_yys_qsryzm')}}
            </div>
          </div>

          <div v-show="!aisSecACCEPT">
            <van-field v-model="Code2" :label="$t('message.th_yys_yzm')" :placeholder="$t('message.th_yys_qsryzm')" :disabled="step_1_load_show" @input="code1Input">
              <template #button>
                <van-button size="small" type="primary" round @click="postCode1" style="min-width: 78px!important;"
                            :disabled="isSend" class="btns">{{timerText}}
                </van-button>
              </template>
            </van-field>
            <div style="color:red;font-size:12px;padding: 10px 16px;" v-show="showError">
              {{$t('message.th_yys_qsryzm')}}
            </div>
          </div>

          <div style="padding: 10px 16px;margin-top: 20px" v-show="!aisSecACCEPT">
            <van-button type="primary" round block @click="postCode2" :loading-text="btn1_text" :loading="step_1_load_show"
                        :disabled="step_1_load" class="btns">{{$t('message.determine')}}
            </van-button>
          </div>
          <div style="padding: 10px 16px;margin-top: 20px" v-show="aisSecACCEPT">
            <van-button type="primary" round block @click="postCode3" loading-text="Loading..." :loading="step_2_load_show"
                        :disabled="step_2_load" class="btns">{{$t('message.determine')}}
            </van-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {yys_isvarify, yys_varify, postRenInfo} from '../../../../ports/port';
  import headNav from "../../../HeadNav/headNav";
  var timer1;
  var timer2;
  var timer3;
  var step1Timer;
  var step2Timer;
  var step3Timer;
  export default {
    name: "yys",
    data() {
      return {
        firstPass: false,//判断第一次是否验证成功
        show: false,
        Code1: '',
        tel: '',
        Code2: '',
        token: JSON.parse(localStorage.getItem('tokenAll')),
        hasvarify: true,
        showYYS: false,
        timerText: this.$t('message.th_yys_hqyzm'),
        isSend: false,
        idcard: '',
        yys_type: '',
        yys_code: '',
        referenceId: '',
        password: '',//运营商密码
        showError: false,//没填的时候报错
        yysmm: false,//没填运营商密码
        aisSecACCEPT: false,//ais 第二步是否完成，完成true,否则false
        step: 1,
        step_1_load: true,
        step_1_load_show:false,
        step_2_load: true,
        step_2_load_show:false,
        LANGS: this.$Language,
        total_rz: 0,//需要认证的步数
        has_rz_total: 0,//已经认证的步数
        // 2023-2.17新增
        btn1_text:'Loading...',
        value1:0,
        option1: [
          { text: 'VIETTEL', value: 1,arr: ['086', '096', '097', '098', '032', '033', '034', '035', '036', '037', '038', '039']},
          { text: 'MOBIFONE', value: 2 ,arr:['089', '090', '093', '070', '079', '077', '076', '078']},
          { text: 'VINAPHONE', value: 3 ,arr:['088', '091', '094', '083', '084', '085', '081', '082']},
          { text: 'VIETNAMOBILE', value: 4 ,arr:['092', '056', '058', '052']}
        ],
        getStep:'',
        hasGetCode1:false
      }
    },
    created() {
      this.$router.replace({
        path: this.$route.path, // 保留当前路径
        query: {
          ...this.$route.query, // 保留已有的 query 参数
          chntoken: sessionStorage.getItem('chntoken')  // 添加新的参数
        }
      });
      this.yys_type = this.$route.query.type;
      this.tel = this.token.phone;
      this.option1.map((e,i)=>{
        const a = e.arr.filter((e2,i2)=>{
          if(e2.includes(this.token.phone.substr(0,2))){
            this.value1 = e.value;
          }
        });
      });
      if(sessionStorage.getItem("step1")){
        clearInterval(step1Timer);
        let time = sessionStorage.getItem("step1",time)-1;
        this.isSend=true;
        step1Timer = setInterval(()=>{
          time--;
          this.timerText = time+'S';
          sessionStorage.setItem("step1",time);
          if(time<1){
            clearInterval(step1Timer);
            sessionStorage.removeItem("step1",time);
            this.timerText = this.$t('message.th_yys_hqyzm');
            this.isSend=false;
          }
        },1000);
      }
      if(sessionStorage.getItem("step2")){
        clearInterval(step2Timer);
        let time = sessionStorage.getItem("step2",time)-1;
        this.aisSecACCEPT = true;
        this.step = 2;
        this.step_2_load = false;
        this.step_2_load_show = false;

        step2Timer = setInterval(()=>{
          time--;
          sessionStorage.setItem("step2",time);
          if(time<1){
            clearInterval(step2Timer);
            sessionStorage.removeItem("step2",time);
            this.aisSecACCEPT = false;
            this.step = 1;
          }
        },1000);
      }
      postRenInfo({userid: this.token.userid})
        .then(res => {
          //is_true=>1未认证 2已认证   is_display=》1显示 0不显示   is_varify=》1必须认证  0不必须认证
          res.data.data.forEach((e, i) => {
            // 获取总共的认证流程的步数
            this.total_rz++;
            // 统计非运营商步骤总共已经认证的
            if (e.is_true == 2 && e.is_varify == 1 && e.is_display == 1 && e.veriry_desc != '运营商') {
              this.has_rz_total++;
            } else if (e.veriry_desc == '运营商' && e.is_varify == 0 && e.is_true == 2) { // 排除如果运营商如果可以跳过
              this.total_rz = this.total_rz - 1;
              this.has_rz_total = this.has_rz_total + 1;
            } else if (e.veriry_desc == '运营商' && e.is_true == 2 && e.is_varify == 1 && e.is_display == 1) {
              this.has_rz_total = this.has_rz_total + 1;
            }
          });
        })
    },
    methods: {
      postCode3() {
        if(this.yys_code.trim()!=''){
          this.step_2_load = true;
          this.step_2_load_show = true;
          yys_varify({userid:this.token.userid,type:2,code:this.yys_code,operator_type:this.value1})
            .then(res=>{
              clearInterval(timer2);
              clearInterval(step3Timer);
              clearInterval(step2Timer);
              sessionStorage.removeItem("step2");
              if(res.data.code==200){
                this.$notify({ type: 'success', message: res.data.msg });
                this.$router.replace({path:'/home'});
              }else{
                clearInterval(timer1);
                this.yys_code = '';
                this.Code2 = '';
                this.timerText = this.$t('message.th_yys_hqyzm');
                this.textCode2="";
                this.$notify({ type: 'danger', message: res.data.msg });
                this.step_2_load = false;
                this.step = 1;
                this.aisSecACCEPT = false;
                this.step_1_load_show = true;
                // 30S后请重新发送验证码
                this.$toast({type:'fail',message:'Vui lòng lấy mã xác nhận sau 30 giây'});
                this.isSend = true;
                let time = 31;
                timer3 = setInterval(() => {
                  time--;
                  this.btn1_text = time + 'S';
                  if (time < 1) {
                    clearInterval(timer3);
                    this.isSend = false;
                    this.step_1_load = false;
                    this.step_1_load_show = false;
                    this.step_1_load = true;
                  }
                }, 1000);
              }
            })
        }
      },
      postCode2() {
        if(this.Code2!=''){
          this.step_1_load = true;
          this.step_1_load_show = true;
          this.hasGetCode1 = false;

          yys_varify({userid:this.token.userid,type:1,code:this.Code2,operator_type:this.value1,step:this.getStep})
            .then(res=>{
              clearInterval(timer1);
              clearInterval(step1Timer);
              sessionStorage.removeItem("step1");
              if(res.data.code==200){
                if(res.data.data.hasOwnProperty('status')){
                  if(res.data.data.status==1){
                    this.$router.replace({path:'/home'});
                  }else if(res.data.data.status==2){
                    clearInterval(timer1);
                    this.timerText = this.$t('message.th_yys_hqyzm');
                    this.step_1_load_show = false;
                    this.isSend = false;
                    this.Code2 = '';
                    this.$toast({type:'fail',message:'Vui lòng lấy mã xác nhận sau 5 giây',duration: 5000,forbidClick:true });//请重新认证运营商
                  }else{
                    this.$notify({ type: 'success', message: res.data.msg });
                    this.aisSecACCEPT = true;
                    this.step = 2;
                    this.step_2_load = false;
                    this.step_2_load_show = false;

                    let time = 61;
                    sessionStorage.setItem("step2",61);
                    step3Timer = setInterval(()=>{
                      time--;
                      sessionStorage.setItem("step2",time);
                      this.timerText = time+'S';
                      if(time<1){
                        clearInterval(step3Timer);
                        sessionStorage.removeItem("step2",time);
                      }
                    },1000);
                  }
                }else{
                  this.$notify({ type: 'success', message: res.data.msg });
                  this.aisSecACCEPT = true;
                  this.step = 2;
                  this.step_2_load = false;
                  this.step_2_load_show = false;

                  let time = 61;
                  sessionStorage.setItem("step2",61);
                  step3Timer = setInterval(()=>{
                    time--;
                    sessionStorage.setItem("step2",time);
                    this.timerText = time+'S';
                    if(time<1){
                      clearInterval(step3Timer);
                      sessionStorage.removeItem("step2",time);
                    }
                  },1000);
                }
              }else{
                this.$notify({ type: 'danger', message: res.data.msg });
                clearInterval(timer1);
                this.timerText = this.$t('message.th_yys_hqyzm');
                this.step_1_load_show = true;
                this.Code2 = '';
                // this.step_1_load = false;
                // 2023-2.17新增
                // 30S后请重新发送验证码
                this.$toast({type:'fail',message:'Vui lòng lấy mã xác nhận sau 30 giây'});
                this.isSend = true;
                let time = 31;
                timer2 = setInterval(() => {
                  time--;
                  this.btn1_text = time + 'S';
                  if (time < 1) {
                    clearInterval(timer2);
                    this.btn1_text = this.$t('message.determine');
                    this.isSend = false;
                    this.step_1_load = true;
                    this.step_1_load_show = false;
                  }
                }, 1000);
              }
            })
          // this.$notify({ type: 'danger', message: '30S后重新发送验证码'});


          //
          // this.step = 2;
          // this.aisSecACCEPT = true;

        }else{
          this.showError = true;
        }
      },
      code2Input(){
        if(this.yys_code.trim().length!=0){
          this.step_2_load = false;
        }else{
          this.step_2_load = true;
        }
      },
      code1Input(){
        if(this.Code2.trim().length!=0 && this.hasGetCode1){
          this.step_1_load = false;
        }else{
          this.step_1_load = true;
        }
      },
      postCode1() {
        let a = this.$route.query.type;
        this.isSend=true;
        let time = 61;
        sessionStorage.setItem("step1",61);
        timer1 = setInterval(()=>{
          time--;
          sessionStorage.setItem("step1",time);
          this.timerText = time+'S';
          if(time<1){
            clearInterval(timer1);
            sessionStorage.removeItem("step1",time);
            this.timerText = this.$t('message.th_yys_hqyzm');
            this.isSend=false;
          }
        },1000);
        this.hasGetCode1 = true;
        yys_varify({userid: this.token.userid, type: 0, code: '', genre: a,operator_type:this.value1})
          .then(res => {
            if (res.data.code == 200) {
              this.$notify({type: 'success', message: res.data.msg});
              this.referenceId = res.data.data.referenceId;
              this.getStep = res.data.data.step;

            } else {
              this.$notify({ type: 'danger', message: res.data.msg });
            }
          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      sendCodeAgain() {
        this.show = true;
        this.postCode1();
      },
      //判断是否已经认证
      isvarify() {
        yys_isvarify({userid: this.token.userid})
          .then(res => {
            if (res.data.code == 200) {
              this.hasvarify = true;
            } else {
              this.hasvarify = false;

              this.show = true;
              switch (this.$route.query.type) {
                case 'ais' :
                  this.postCode1('ais');
                  break;
                case 'dtac':

                  break;
                default :

              }
            }

          })
          .catch(err => {
            this.$store.commit('edit', false);//关闭全局的loading
            if (err.toString().indexOf('timeout') != -1) {
              this.$toast({message: this.$t("message.service_timeout"), type: 'danger', icon: 'fail'});
            }
          })
      },
      gorz() {
        // let phone = this.token.phone;
        // let host = window.location.host;
        // window.open("http://H5.th.v1c.cc/mall/Thailand001?cell="+phone+"&callBack="+host+"/perInfoHome/Social")
        this.showYYS = true;
      },
      closePop() {
        this.showYYS = false;
      },
      backPrev() {
        this.$router.go(-1);
      }
    },
    components: {
      headNav
    }
  }
</script>

<style scoped lang="scss">
  .btns {
    @include defaultBtn;
  }

  #sendAgagin {
    margin: 30px auto 30px;
    display: block;
    padding: 0 60px;
    background: $color;
    border: 1px solid $color;
    border-radius: 5px;
    width: 100%;
  }

  #backPrev {
    margin: 30px auto 30px;
    display: block;
    padding: 0 60px;
    width: 100%;
    border-radius: 5px;
  }

  .yys_item {
    padding: 20px;
    font-size: 16px;
    color: #323233;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .yys_item1 {
    border-bottom: 4px solid #eceaea;
  }

  .pop_title {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    padding: 15px;
    border-bottom: 1px solid #eceaea;
    background: #f4f8ff;
  }

  /deep/ .van-popup {
    background: transparent;
  }

  .section1 {
    min-height: 30vh;
    background-size: 25rem auto;
  }

  .section2 {
    margin-top: 1rem;
  }

  .section3 {
    min-height: 17vh;
    background-size: 25rem auto;
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .container {
    padding: 1.6rem 15px 0.5rem;
    background-color: #fff;

    .circle {
      width: 0.19rem;
      height: 0.19rem;
      background-color: #D5D5D5;
      border-radius: 0.19rem;
      display: inline-block;
      margin-right: 5px;
    }

    .circle1 {
      width: 0.53rem;
      height: 0.53rem;
      background: $color;
      border-radius: 50%;
      color: #fff;
      text-align: center;
      line-height: 0.53rem;
    }

    .scsf {
      & :nth-child(1) {
        font-size: 0.53rem;
        font-weight: 600;
        color: $color;
        margin: 0.36rem 0 0.3rem;
      }

      & :nth-child(2) {
        font-size: 0.37rem;
        font-weight: 300;
        color: #878686;
      }

      ~ div {
        text-align: center;
        margin-top: 2rem;

        img {
          height: 5.47rem;
          width: 2.83rem;
        }
      }
    }
  }
  /deep/ .van-field__label{
    width: 7.2em!important;
  }
  /deep/ .van-dropdown-menu__bar{
    background-color: transparent;
    box-shadow: none;
    height: auto;
  }
  /deep/ .van-dropdown-menu__title{
    font-size: 14px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/loanRecord/personInfo/yys/yys_send.vue